import React, { useState } from 'react'
import { Box, Button, TextField, Typography } from '@mui/material'
import DrawerNav from '../DrawerNav/DrawerNav'
import { BASE_URL } from '../../Api/Constants'
import { useNavigate } from 'react-router-dom'

export default function AddExam() {
    const [name, setName] = useState('')
    const [description, setDescription] = useState('')
    const navigate = useNavigate()

    const handleSaveChanges = async () => {
        try {
            const response = await fetch(`${BASE_URL}/api/exams`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    name,
                    description,
                })
            })

            const data = await response.json()

            if (response.ok) {
                setName('')
                setDescription('')
                navigate('/view-exams')
            } else {
                console.error(data.message)
            }
        } catch (error) {
            console.error('Error:', error)
        }
    }

    return (
        <Box sx={{ display: 'flex' }}>
            <DrawerNav />
            <Box component='main' sx={{ flexGrow: 1, p: 3 }}>
                <Box p={2}>
                    <Typography variant='h4' sx={{ my: 2, fontWeight: 'bolder', color: '#4b4848' }}>
                        Add Exam
                    </Typography>
                    <TextField label='Exam Name' value={name} onChange={(event) => setName(event.target.value)} fullWidth variant='outlined' margin='normal' />
                    <TextField label='Exam Description' value={description} onChange={(event) => setDescription(event.target.value)} fullWidth variant='outlined' margin='normal' />
                    <Box mt={2}>
                        <Button variant='contained' color='success' onClick={handleSaveChanges}>
                            Add Exam
                        </Button>
                    </Box>
                </Box>
            </Box>
        </Box>
    )
}
